const redirect = (state: any = {}, action: any) => {
  switch (action.type) {
    case 'RECEIVE_REDIRECT':
      return {
        ...state,
        url: action.url,
      };
    case 'RECEIVE_REDIRECT_ERROR':
      return {
        ...state,
        hasError: action.hasError
      };
    default:
      return state;
  }
};

export default redirect;
